export const StatusDot = ({ status }: { status: number }) => {
  function Dot() {
    switch (status) {
      case 1:
        return (
          <svg fill='none' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'>
            <path
              clipRule='evenodd'
              d='M9.3657 3.98203C10.5364 1.94544 13.4637 1.94544 14.6334 3.98203L22.0886 16.9632C23.2583 18.9998 21.7946 21.5455 19.4542 21.5455H4.54496C2.20453 21.5455 0.741884 18.9998 1.91159 16.9632L9.36468 3.98203H9.3657ZM12.0001 9.325C12.2017 9.325 12.3951 9.40546 12.5376 9.54868C12.6802 9.69191 12.7603 9.88616 12.7603 10.0887V13.9073C12.7603 14.1099 12.6802 14.3041 12.5376 14.4473C12.3951 14.5906 12.2017 14.671 12.0001 14.671C11.7985 14.671 11.6051 14.5906 11.4625 14.4473C11.32 14.3041 11.2399 14.1099 11.2399 13.9073V10.0887C11.2399 9.88616 11.32 9.69191 11.4625 9.54868C11.6051 9.40546 11.7985 9.325 12.0001 9.325ZM12.0001 17.7259C12.2017 17.7259 12.3951 17.6454 12.5376 17.5022C12.6802 17.359 12.7603 17.1647 12.7603 16.9622C12.7603 16.7596 12.6802 16.5654 12.5376 16.4221C12.3951 16.2789 12.2017 16.1985 12.0001 16.1985C11.7985 16.1985 11.6051 16.2789 11.4625 16.4221C11.32 16.5654 11.2399 16.7596 11.2399 16.9622C11.2399 17.1647 11.32 17.359 11.4625 17.5022C11.6051 17.6454 11.7985 17.7259 12.0001 17.7259Z'
              fill='var(--ion-color-warning)'
              fillRule='evenodd'
            />
            <path
              d='M12.5376 9.54868C12.3951 9.40546 12.2017 9.325 12.0001 9.325C11.7985 9.325 11.6051 9.40546 11.4625 9.54868C11.32 9.69191 11.2399 9.88616 11.2399 10.0887V13.9073C11.2399 14.1099 11.32 14.3041 11.4625 14.4473C11.6051 14.5906 11.7985 14.671 12.0001 14.671C12.2017 14.671 12.3951 14.5906 12.5376 14.4473C12.6802 14.3041 12.7603 14.1099 12.7603 13.9073V10.0887C12.7603 9.88616 12.6802 9.69191 12.5376 9.54868Z'
              fill='white'
            />
            <path
              d='M12.5376 17.5022C12.3951 17.6454 12.2017 17.7259 12.0001 17.7259C11.7985 17.7259 11.6051 17.6454 11.4625 17.5022C11.32 17.359 11.2399 17.1647 11.2399 16.9622C11.2399 16.7596 11.32 16.5654 11.4625 16.4221C11.6051 16.2789 11.7985 16.1985 12.0001 16.1985C12.2017 16.1985 12.3951 16.2789 12.5376 16.4221C12.6802 16.5654 12.7603 16.7596 12.7603 16.9622C12.7603 17.1647 12.6802 17.359 12.5376 17.5022Z'
              fill='white'
            />
          </svg>
        );
      case 2:
        return (
          <svg fill='none' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'>
            <circle cx='12' cy='12' fill='var(--ion-color-success)' r='10' />
            <path
              d='M8.67505 12.3326L11.335 14.9926L15.325 9.00757'
              stroke='white'
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth='1.5'
            />
          </svg>
        );
      default:
        return (
          <svg fill='none' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'>
            <path
              clipRule='evenodd'
              d='M9.3657 3.98203C10.5364 1.94544 13.4637 1.94544 14.6334 3.98203L22.0886 16.9632C23.2583 18.9998 21.7946 21.5455 19.4542 21.5455H4.54496C2.20453 21.5455 0.741884 18.9998 1.91159 16.9632L9.36468 3.98203H9.3657Z'
              fill='var(--ion-color-danger)'
              fillRule='evenodd'
            />
            <path
              clipRule='evenodd'
              d='M8.6711 10.6711C8.8989 10.4433 9.26825 10.4433 9.49606 10.6711L12.0002 13.1753L14.5044 10.6711C14.7322 10.4433 15.1016 10.4433 15.3294 10.6711C15.5572 10.8989 15.5572 11.2683 15.3294 11.4961L12.8252 14.0002L15.3294 16.5044C15.5572 16.7322 15.5572 17.1016 15.3294 17.3294C15.1016 17.5572 14.7322 17.5572 14.5044 17.3294L12.0002 14.8252L9.49606 17.3294C9.26825 17.5572 8.8989 17.5572 8.6711 17.3294C8.44329 17.1016 8.44329 16.7322 8.6711 16.5044L11.1753 14.0002L8.6711 11.4961C8.44329 11.2683 8.44329 10.8989 8.6711 10.6711Z'
              fill='white'
              fillRule='evenodd'
            />
          </svg>
        );
    }
  }

  return <Dot />;
};
